import React from 'react'
import { Box, Text } from '@workwhile/ui'
import { usePendingApprovalsContextValue } from '../context/PendingApprovalsProvider'
import { PendingApprovalsTable } from './PendingApprovalsTable'

export const PendingApprovalsMain = () => {
  const {
    state: { positionId, upcoming, past },
    actions: { loadMoreUpcoming, loadMorePast },
  } = usePendingApprovalsContextValue()

  const sections = [
    {
      title: 'Upcoming shifts',
      table: upcoming,
      onLoadMore: loadMoreUpcoming,
    },
    {
      title: 'Past shifts',
      table: past,
      onLoadMore: loadMorePast,
    },
  ] as const

  return (
    <Box>
      {sections.map(({ title, table, onLoadMore }, index) => (
        <Box key={title} mb={index < sections.length - 1 ? 4 : undefined}>
          <Text fontWeight="bold" mb={2}>
            {title}
          </Text>
          <PendingApprovalsTable
            table={table}
            positionId={positionId}
            onLoadMore={onLoadMore}
          />
        </Box>
      ))}
    </Box>
  )
}
